import { render, staticRenderFns } from "./ForumPostRequests.vue?vue&type=template&id=7c1d8b5c&scoped=true&"
import script from "./ForumPostRequests.vue?vue&type=script&lang=js&"
export * from "./ForumPostRequests.vue?vue&type=script&lang=js&"
import style0 from "./ForumPostRequests.vue?vue&type=style&index=0&id=7c1d8b5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1d8b5c",
  null
  
)

export default component.exports